var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_354_40137",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 86,
    height: 85
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.763184 0H85.3036V84.5405H0.763184V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_354_40137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0331 0C19.688 0 0.763184 18.9252 0.763184 42.2706C0.763184 65.6153 19.688 84.5405 43.0331 84.5405C66.3784 84.5405 85.3036 65.6153 85.3036 42.2706C85.3036 18.9252 66.3784 0 43.0331 0Z",
    fill: "#A7A7A7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.8526 30.6849C61.4463 30.6849 56.2527 35.8785 56.2527 42.2848C56.2527 48.6911 61.4463 53.8847 67.8526 53.8847C73.6565 53.8779 78.5626 49.5821 79.335 43.8309H72.7149C72.0594 45.8931 70.1309 47.3868 67.8526 47.3868C65.035 47.3868 62.7516 45.1024 62.7516 42.2858C62.7516 39.4682 65.036 37.1848 67.8526 37.1838C70.1309 37.1838 72.0604 38.6775 72.7149 40.7397H79.336C78.5626 34.9865 73.6565 30.6916 67.8526 30.6849ZM18.1598 47.3858C15.3422 47.3858 13.0588 45.1014 13.0588 42.2838C13.0588 39.4661 15.3432 37.1828 18.1598 37.1828C20.9775 37.1828 23.2609 39.4671 23.2609 42.2838C23.2609 45.1024 20.9765 47.3858 18.1598 47.3858ZM29.7597 53.6885V42.2848C29.7597 35.8785 24.5662 30.6849 18.1598 30.6849C11.7535 30.6849 6.55994 35.8785 6.55994 42.2848C6.55994 48.6911 11.7535 53.8847 18.1598 53.8847C20.0501 53.8817 22.0096 53.0789 23.3906 51.7435V53.6885H29.7597ZM42.9807 37.1838C45.7984 37.1838 48.0818 39.4682 48.0818 42.2858C48.0818 45.1038 45.7974 47.3868 42.9807 47.3868C40.1631 47.3868 37.8797 45.1024 37.8797 42.2858C37.8797 39.4671 40.1631 37.1838 42.9807 37.1838ZM31.3808 24.976V42.2848C31.3808 48.6911 36.5744 53.8847 42.9807 53.8847C49.3878 53.8847 54.5807 48.6911 54.5807 42.2848C54.5807 35.8785 49.3878 30.6849 42.9807 30.6849C41.2121 30.6876 39.3809 31.2506 37.8797 32.2678V24.976H31.3808Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbc);
export default __webpack_public_path__ + "static/media/abc.5414a644c6fc58d37a4860f50eb3e3de.svg";
export { ForwardRef as ReactComponent };